var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    { attrs: { "no-margin": "" } },
    [
      _c(
        "w-col",
        { attrs: { lg: "6", sm: "6", xl: "6", xs: "12" } },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(" Toekennen aan afdeling:"),
          ]),
          _vm._l(_vm.departments, function (dep, index) {
            return _c(
              "w-button",
              {
                key: index,
                style: { maxWidth: "180px", marginBottom: "10px" },
                on: {
                  click: function ($event) {
                    return _vm.updateWithDepartement(dep)
                  },
                },
              },
              [
                _vm._t("default", function () {
                  return [
                    _vm._v(" " + _vm._s(_vm.getDepartmentName(dep)) + " "),
                  ]
                }),
              ],
              2
            )
          }),
        ],
        2
      ),
      _c(
        "w-col",
        { attrs: { lg: "6", sm: "6", xl: "6", xs: "12" } },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(" Toekennen aan collega:"),
          ]),
          _c("w-checkbox", {
            attrs: { label: "Alle collega's" },
            on: {
              input: function ($event) {
                return _vm.checkAll()
              },
            },
          }),
          _c("w-divider"),
          _vm._l(_vm.admins, function (admin, index) {
            return _c("w-checkbox", {
              key: index,
              attrs: {
                label: _vm.adminLabelName(admin),
                value: _vm.isChecked(admin),
              },
              on: {
                input: function ($event) {
                  return _vm.updateAdmin(admin, $event)
                },
              },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }